import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';

import FlatButton from 'material-ui/FlatButton';
import TextField from '@material-ui/core/TextField';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import { MdWarning as WarningIcon } from 'react-icons/md';
import { BounceLoader } from 'halogenium';
import withMobileDialog from '@material-ui/core/withMobileDialog';

import { localize } from 'react-localize-redux';

import { twoFactorAuth } from 'actions/authenticationActions';
import { colors } from 'helpers/ColorHelper';
import { AccentColor } from 'helpers/AccentColorHelper';

const VERIFICATION_SMS = 'sms';
const VERIFICATION_EMAIL = 'email';

const style = {
  button: {
    marginTop: '20px',
    width: '100%',
    color: 'white',
    fontSize: '18px',
    height: '50px',
  },
};

const TwoFactorAuth = withMobileDialog()(
  connect(
    (store) => ({
      verificationStep: store.authentication.twoAuthVerification.verificationStep,
      previewMobileNumber: store.authentication.twoAuthVerification.previewMobileNumber,
      errorCode: store.authentication.twoAuthVerification.errorCode,
      hasPhoneNumber: store.authentication.twoAuthVerification.hasPhoneNumber,
    }),
    {
      twoFactorAuth,
    }
  )(
    class TwoFactorAuth extends Component {
      constructor(props) {
        super(props);
        this.state = {
          verificationCode: '',
          verificationMethod: '',
          errorCode: '',
        };
      }

      handleInputChange = (event) => {
        this.setState({ [event.target.name]: event.target.value.trim() });
      };

      detectEnterKeyDown = (event) => {
        if (event.key === 'Enter') {
          this.verifyUser();
        }
      };

      verifyByEmail = () => {
        this.setState({
          errorCode: '',
          verificationMethod: VERIFICATION_EMAIL,
        });
        const formData = {
          verification_code: '',
          verification_method: VERIFICATION_EMAIL,
        };
        this.props.handleVerification(formData, this.props.onSuccessfulVerification);
        this.setState({ verificationCode: '' });
      };

      verifyBySMS = () => {
        this.setState({
          errorCode: '',
          verificationMethod: VERIFICATION_SMS,
        });
        const formData = {
          verification_code: '',
          verification_method: VERIFICATION_SMS,
        };
        this.props.handleVerification(formData, this.props.onSuccessfulVerification);
        this.setState({ verificationCode: '' });
      };

      verifyUser = () => {
        this.setState({
          errorCode: '',
        });

        if (this.state.verificationCode === '') {
          this.setState({ errorCode: 'verificationRequired.codeBlankError' });
          return;
        }

        const formData = {
          verification_code: this.state.verificationCode,
          verification_method: this.state.verificationMethod,
        };
        this.props.handleVerification(formData, this.props.onSuccessfulVerification);
        this.setState({ verificationCode: '' });
      };

      render() {
        return (
          <Fragment>
            <Dialog
              fullScreen={this.props.fullScreen}
              open={this.props.isOpen}
              onClose={this.props.toggleDialog}
              aria-labelledby="two-auth-verification"
              disableBackdropClick
              disableEscapeKeyDown
              classes={{
                paper: 'form-dialog',
              }}
              id="verificationAuthDialog"
            >
              <DialogTitle>
                <h3 style={{ margin: '10px 0 5px', textAlign: 'center' }}>
                  {this.props.translate('verificationRequired')}
                  <b style={{ fontFamily: 'Circular-Black', color: AccentColor() }}>.</b>
                </h3>
              </DialogTitle>
              <DialogContent>
                <div style={{ borderTop: `5px solid ${AccentColor()}`, marginTop: '5px' }}>
                  {this._renderLoading()}
                  {this._renderError()}
                  {this._renderVerificationMethod()}
                  {this._renderVerificationStep()}
                </div>
              </DialogContent>
              <DialogActions style={{ display: 'block' }}>
                {this._renderDialogActions()}
              </DialogActions>
            </Dialog>
          </Fragment>
        );
      }

      _renderError = () => {
        if (this.state.errorCode === '' && this.props.errorCode === '') return null;
        const errorCode = this.state.errorCode || this.props.errorCode;
        return (
          <div className="error-message" style={{ textAlign: 'center' }}>
            <WarningIcon /> {this.props.translate(errorCode)}
          </div>
        );
      };

      _renderDialogActions = () => (
        <Fragment>
          <FlatButton
            onClick={this.props.toggleDialog}
            id="close-button"
            style={{ color: AccentColor(), textTransform: 'uppercase' }}
          >
            {this.props.translate('close')}
          </FlatButton>
          {this.props.verificationStep === 'verification_code' && (
            <FlatButton
              variant="raised"
              onClick={this.verifyUser}
              disabled={this.props.verificationStep === 'loading'}
              id="submit-button"
              style={{
                color: 'white',
                backgroundColor:
                  this.props.verificationStep === 'loading' ? colors.LIGHT_GRAY : AccentColor(),
                textTransform: 'uppercase',
              }}
            >
              {this.props.translate('verify')}
            </FlatButton>
          )}
        </Fragment>
      );

      _renderLoading = () => {
        if (this.props.verificationStep !== 'loading') return null;
        return (
          <div className="row">
            <div
              style={{
                textAlign: 'center',
                width: '60px',
                margin: '30px auto auto auto',
              }}
            >
              <BounceLoader color={AccentColor()} />
            </div>
          </div>
        );
      };

      _renderVerificationMethod = () => {
        if (this.props.verificationStep !== 'verification_method') return null;

        return (
          <div style={{ textAlign: 'center', marginTop: '15px' }}>
            <p style={{ fontSize: '16px' }}>
              {this.props.translate('verificationRequired.verificationMethod')}
            </p>
            <div className="row">
              <div className="col-sm-6 col-sm-offset-3">
                {this.props.hasBouncedEmail !== true && (
                  <FlatButton
                    name="submit"
                    label={this.props.translate('verificationRequired.sendEmail')}
                    primary={true}
                    onClick={this.verifyByEmail}
                    backgroundColor={AccentColor()}
                    hoverColor="grey"
                    labelStyle={{ textTransform: 'capitalize', fontSize: '18px' }}
                    style={style.button}
                  />
                )}
                {this._renderSMSVerificationButton()}
              </div>
            </div>
          </div>
        );
      };

      _renderSMSVerificationButton = () => {
        return (
          <Fragment>
            <FlatButton
              disabled={!this.props.hasPhoneNumber}
              name="submit"
              label={this.props.translate('verificationRequired.sendSMS')}
              primary={true}
              onClick={this.verifyBySMS}
              backgroundColor={this.props.hasPhoneNumber ? AccentColor() : 'grey'}
              hoverColor="grey"
              labelStyle={{ textTransform: 'capitalize', fontSize: '18px' }}
              style={style.button}
            />
            {!this.props.hasPhoneNumber && (
              <div style={{ marginTop: '15px' }}>
                <p>{this.props.translate('verifictaionRequired.noPhoneNumber')}</p>
              </div>
            )}
          </Fragment>
        );
      };

      _renderVerificationStep = () => {
        if (this.props.verificationStep !== 'verification_code') return null;
        return (
          <div style={{ textAlign: 'center', marginTop: '15px' }}>
            <p style={{ fontSize: '15px' }}>
              {this.props.translate('verificationRequired.verificationCode')}
            </p>
            <div className="row">
              <div className="col-sm-6 col-sm-offset-3">
                <TextField
                  name="verificationCode"
                  label="verification code"
                  floatingLabelText="Verfication Code"
                  onChange={this.handleInputChange}
                  value={this.state.verificationCode}
                  onKeyDown={this.detectEnterKeyDown}
                  variant="outlined"
                  style={{ marginTop: '5px' }}
                />
              </div>
            </div>
            {this.state.verificationMethod === VERIFICATION_EMAIL &&
            this.props.hasBouncedEmail !== true ? (
              <button type="button" className="link-button" onClick={this.verifyByEmail}>
                {this.props.translate('verificationRequired.sendByEmail')}
              </button>
            ) : (
              <button type="button" className="link-button" onClick={this.verifyBySMS}>
                {this.props.translate('verificationRequired.sendBySMS')}
              </button>
            )}
          </div>
        );
      };
    }
  )
);

export default localize()(TwoFactorAuth);
